<main class="main h-full">
  
  <ng-container *ngIf="isHandset; else webTemplate"> 
      
    <app-handset-layout class="h-full">
      <app-standard-header-layout id="header">
        <app-profile id="profilePart"></app-profile>  
        <app-title></app-title>
      </app-standard-header-layout>
      <div class="h-full">
        <router-outlet />
      </div>
    </app-handset-layout>

  </ng-container> 

  <ng-template #webTemplate>

    <app-web-layout class="h-full">
      <app-standard-header-layout id="header">
        <app-profile id="profilePart"></app-profile>
        <app-title></app-title>
      </app-standard-header-layout>
      <div id="menu">
        <app-main-menu></app-main-menu>
      </div>
      <div class="h-full">
        <router-outlet />
      </div>
    </app-web-layout>

  </ng-template>

  <!--<div>
    <button class="btn-default" (click)="logout()">Log out</button>
  </div>-->
  
</main>